import { Badge, OverlayTrigger, Tooltip } from 'react-bootstrap';

import type { Client } from '@/api/user/getCurrentUser.ts';
import { useUserContext } from '@/context/UserContext.tsx';

export function MaybePrimeBrokenBadge({ primeBroker }: { primeBroker: Client['primeBroker'] }) {
  const {
    currentUser: { userType },
  } = useUserContext();
  if (!primeBroker || userType !== 'Internal Sales') {
    return null;
  }

  return (
    <OverlayTrigger
      overlay={(props) => (
        <Tooltip {...props} data-e2e="prime-broker-name">
          {primeBroker}
        </Tooltip>
      )}
      placement="top"
    >
      <Badge bg="secondary" pill data-e2e="prime-broker-badge">
        PB
      </Badge>
    </OverlayTrigger>
  );
}
